import React from "react";
import "./home.css";

const Home = () => {
  return (
    <main>
      <div className="main-card">
        <section className="home-section">
          <h1>Welcome to FileSphere</h1>
          <p>Your one-stop solution for managing documents efficiently.</p>
          <img src="images/filesphere-favicon-color.png" alt="FileSphere Logo" />
          <br />
        </section>
      </div>
    </main>
  );
};

export default Home;
